import AuthContext from 'context/authContext';
import React, { useContext } from 'react';
import SchoolForm from './SchoolForm';
import useUpload from 'hooks/useUpload';
import { useNavigate } from 'react-router-dom';
import paths from 'routes/paths';
import { useCreateSchool } from 'hooks/useBeneficiaries';

function AddSchool() {
  const navigate = useNavigate();
  const { upload, loading: uploadLoading } = useUpload();
  const { organization, selectedBranchId } = useContext(AuthContext);
  const { createSchoolAsync, isCreating } = useCreateSchool();

  const submit = async values => {
    try {
      if (values.school_document && typeof values.school_document !== 'string') {
        const school_document = await upload(values.school_document);
        values.school_document = school_document;
      }

      // Destructure to exclude form fields that need to be renamed
      const { address, city, email, schoolName, contact, schoolHeadTeacher, ...rest } = values;

      const schoolData = {
        ...rest,
        organisation_id: organization.id,
        school_address: address,
        school_city: city,
        school_email: email,
        school_name: schoolName,
        school_number: contact,
        school_headteacher: schoolHeadTeacher
      };

      // Only add branch_id if it's not 'all'
      if (selectedBranchId && selectedBranchId !== 'all') {
        schoolData.branch_id = selectedBranchId;
      }

      await createSchoolAsync(schoolData);
      navigate(paths.school);
    } catch (error) {
      console.error('Error creating school:', error);
    }
  };

  return <SchoolForm onSubmit={submit} loading={isCreating || uploadLoading} />;
}

export default AddSchool;
